import { SftpPushPendingRecordsTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { TableCellType, TableHeader } from "../../../custom-table/table";

export const generateSftpPushPendingRecordsTableHeaders = (): TableHeader[] => {
  return [
    {
      label: "",
      key: SftpPushPendingRecordsTableColumnKeys.SELECT,
      order: 1,
      width: 5,
      type: TableCellType.CHECKBOX,
    },
    {
      label: "Filename",
      key: SftpPushPendingRecordsTableColumnKeys.FILENAME,
      order: 2,
      width: 43,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Row Count",
      key: SftpPushPendingRecordsTableColumnKeys.ROW_COUNT,
      order: 3,
      width: 11,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Resubmit Count",
      key: SftpPushPendingRecordsTableColumnKeys.RESUBMIT_COUNT,
      order: 4,
      width: 13,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "Pending Count",
      key: SftpPushPendingRecordsTableColumnKeys.PENDING_COUNT,
      order: 5,
      width: 13,
      type: TableCellType.STRING,
      sortable: true,
    },
    {
      label: "DOW",
      key: SftpPushPendingRecordsTableColumnKeys.DUMPED_AT,
      order: 6,
      width: 15,
      type: TableCellType.STRING,
      sortable: true,
    },
  ];
};
